import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Definitionscertificate_interface, Empty_Definitionscertificate_interface } from 'src/app/Interface/Definitionscertificate_interface';
import { Empty_QUANTITY_Interface, QUANTITY_Interface } from 'src/app/Interface/QUANTITY_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DefinitionscertificateService } from 'src/app/Service/Definitionscertificate/Definitionscertificate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { QUANTITYService } from 'src/app/Service/QUANTITY/QUANTITY.service';

@Component({
  selector: 'app-DefinitionscertificateAdd',
  templateUrl: './DefinitionscertificateAdd.component.html',
  styleUrls: ['./DefinitionscertificateAdd.component.scss']
})
export class DefinitionscertificateAddComponent implements OnInit {

  constructor(
    private Definitionscertificate_Service:DefinitionscertificateService,
    private Nav_Service:NavService,
    private Quantity_Service:QUANTITYService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewDefinitionscertificate=new FormGroup({
      id :new FormControl(),
      CALIBRATIONMETHOD:new FormControl(null,Validators.required),
      UNCERTAINTY:new FormControl(null,Validators.required),
      TRACEABILITY:new FormControl(null,Validators.required),
      DecisionRule:new FormControl(null,Validators.required),
      Code:new FormControl(null,Validators.required),

    })


    this.Nav_Service.CheckValidPage(1079).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewDefinitionscertificate:FormGroup;

  get_Form_DecisionRule(){
    return this.AddNewDefinitionscertificate.get('DecisionRule') as FormControl;
  }

  get_Form_TRACEABILITY(){
    return this.AddNewDefinitionscertificate.get('TRACEABILITY') as FormControl;
  }

  get_Form_UNCERTAINTY(){
    return this.AddNewDefinitionscertificate.get('UNCERTAINTY') as FormControl;
  }

  get_Form_CALIBRATIONMETHOD(){
    return this.AddNewDefinitionscertificate.get('CALIBRATIONMETHOD') as FormControl;
  }
  get_Form_Code(){
    return this.AddNewDefinitionscertificate.get('Code') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewDefinitionscertificate(){
    var Record:Definitionscertificate_interface =Empty_Definitionscertificate_interface()
    Record.id=0
    Record.quantity_id=this.Data_Seleted_Record.id
    Record.decisionRule=this.get_Form_DecisionRule().value
    Record.tRACEABILITY=this.get_Form_TRACEABILITY().value
    Record.uNCERTAINTY=this.get_Form_UNCERTAINTY().value
    Record.cALIBRATIONMETHOD=this.get_Form_CALIBRATIONMETHOD().value
    Record.code=this.get_Form_Code().value
    this.InProccessing=true
    this.Definitionscertificate_Service.AddDefinitionscertificate(Record).subscribe(
      data=>{
        this.InProccessing=false
        this.AddNewDefinitionscertificate.reset()
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
      }
    )
  }





    //#region  کمیت

    modalRef_QUANTITY: any;
    page:number=0

    ProcssingQUANTITY:boolean=false

    Search_Name_QUANTITY_Table:string=''

    openModal_QUANTITY(template: TemplateRef<any>) {
      this.modalRef_QUANTITY = this.modalService.show(template);
    }

    DataList_QUANTITY:Array<QUANTITY_Interface>=[]
    Data_Seleted_Record:QUANTITY_Interface=Empty_QUANTITY_Interface()



    ReadData_QUANTITY(){
      this.ProcssingQUANTITY=true
      this.Quantity_Service.GetActive().subscribe(
        data=>{
          this.DataList_QUANTITY=data
          this.ProcssingQUANTITY=false
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }

    Set_Selected_QUANTITY_Record(item){
      this.Data_Seleted_Record=item
      this.modalRef_QUANTITY.hide()
    }

    //#endregion

}
